<template>
    <div class="divide-gray-200">
        <div class="py-6 text-center" v-show="!isLoaded">
            <font-awesome-icon class="text-gray-500" :icon="['fas', 'circle-notch']" transform="grow-6" spin />
        </div>
        <div class="" v-show="isLoaded">
            <div class="divide-y">
                <div class="space-y-6 sm:space-y-5">
                    <div class="sm:grid sm:grid-cols-3 sm:gap-4 sm:items-start sm:pt-5">
                        <label for="city" class="block text-sm font-medium text-gray-700 sm:mt-px sm:pt-2">
                            {{ $t("messages.player.playerConfig.maxWithdrawCount") }}
                        </label>
                        <div class="mt-1 sm:mt-0 sm:col-span-2">
                            <input type="number" name="city" id="city" v-model.number="formData.max_withdraw_count"
                                class="max-w-lg block w-full shadow-sm focus:ring-indigo-500 focus:border-indigo-500 sm:max-w-xs sm:text-sm border-gray-300 rounded-md" />
                            <span class="inline-block text-sm mt-2 text-red-500">{{
                                $t("messages.player.playerConfig.withdrawCountLimit") }}</span>
                        </div>
                    </div>

                    <div class="sm:grid sm:grid-cols-3 sm:gap-4 sm:items-start sm:border-t sm:border-gray-200 sm:pt-5">
                        <label for="state" class="block text-sm font-medium text-gray-700 sm:mt-px sm:pt-2">
                            {{ $t("messages.player.playerConfig.maxWithdrawBasedMinutes") }}
                        </label>
                        <div class="mt-1 sm:mt-0 sm:col-span-2">
                            <input type="number" max="100" min="1"
                                v-model.number="formData.max_withdraw_count_base_minute" name="state" id="state"
                                class="max-w-lg block w-full shadow-sm focus:ring-indigo-500 focus:border-indigo-500 sm:max-w-xs sm:text-sm border-gray-300 rounded-md" />
                            <span class="inline-block text-sm mt-2 text-red-500">{{
                                $t("messages.player.playerConfig.doNotChange") }}
                            </span>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="pt-5">
            <div class="flex justify-end">
                <button type="button" @click="saveConfig()"
                    class="ml-3 inline-flex justify-center py-2 px-4 border border-transparent shadow-sm text-sm font-medium rounded-md text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500">
                    {{ $t("messages.player.playerConfig.save") }}
                </button>
            </div>
        </div>
    </div>
</template>

<script>
import {
    CheckCircleIcon,
    ChevronLeftIcon,
    ChevronRightIcon,
    MailIcon,
    HomeIcon,
    SearchIcon,
} from "@heroicons/vue/solid";
import { inject, onMounted, ref } from "@vue/runtime-core";
import { useStore } from "vuex";
import * as dayjs from "dayjs";
import localizedFormat from "dayjs/plugin/localizedFormat";
import { useRoute, useRouter } from "vue-router";

dayjs.extend(localizedFormat);

const pages = [
    { name: "Players", href: { name: "Player List" }, current: false },
];

export default {
    components: {
        ChevronLeftIcon,
        ChevronRightIcon,
        CheckCircleIcon,
        MailIcon,
        HomeIcon,
        SearchIcon,
    },
    setup() {
        const axios = inject("$axios");
        const store = useStore();
        const route = useRoute();
        let isLoaded = ref(false);
        let formData = ref({
            operator_id: store.state.selectedOperator.operatorId,
            user_id: route.params.id,
            max_withdraw_count: 5,
            max_withdraw_count_base_minute: 1440,
            adminId: store.state.user.id,
        });

        onMounted(() => {
            fetch();
        });

        const fetch = () => {
            axios
                .post(
                    process.env.VUE_APP_API_ENDPOINT +
                    "/admin/api/v1/be-payment/user-bank",
                    {
                        userId: route.params.id,
                    }
                )
                .then(({ data }) => {
                    formData.value.max_withdraw_count = data.maxWithdrawCount || 0;
                    formData.value.max_withdraw_count_base_minute = data.maxWithdrawPerMinute || 0
                    isLoaded.value = true;
                })
                .catch(({ response }) => {
                    console.log(response.data);
                });
        };

        const saveConfig = () => {
            isLoaded.value = false;
            axios
                .post(
                    process.env.VUE_APP_API_ENDPOINT +
                    "/admin/api/v1/be-payment/user-bank/max-withdraw/update",
                    formData.value
                )
                .then(({ data }) => {
                    fetch();
                })
                .catch(({ response }) => {
                    console.log(response.data);
                });
        };

        return {
            isLoaded,
            route,
            formData,
            saveConfig,
        };
    },
};
</script>